// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AttendeesModalController from "./attendees_modal_controller"
application.register("attendees-modal", AttendeesModalController)

import BulkPaymentController from "./bulk_payment_controller"
application.register("bulk-payment", BulkPaymentController)

import ChangePasswordController from "./change_password_controller"
application.register("change-password", ChangePasswordController)

import DateDdMmYyyyController from "./date_dd_mm_yyyy_controller"
application.register("date-dd-mm-yyyy", DateDdMmYyyyController)

import DeleteWorkBlockController from "./delete_work_block_controller"
application.register("delete-work-block", DeleteWorkBlockController)

import EditWorkTimeController from "./edit_work_time_controller"
application.register("edit-work-time", EditWorkTimeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KebabMenuController from "./kebab_menu_controller"
application.register("kebab-menu", KebabMenuController)

import ModifyPaymentController from "./modify_payment_controller"
application.register("modify-payment", ModifyPaymentController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PaymentDiscountController from "./payment_discount_controller"
application.register("payment-discount", PaymentDiscountController)

import PhoneUyController from "./phone_uy_controller"
application.register("phone-uy", PhoneUyController)

import PriorityQueueController from "./priority_queue_controller"
application.register("priority-queue", PriorityQueueController)

import ScheduleCategorySyncController from "./schedule_category_sync_controller"
application.register("schedule-category-sync", ScheduleCategorySyncController)

import ScheduleFormController from "./schedule_form_controller"
application.register("schedule-form", ScheduleFormController)

import ScheduleOccupancyWarningController from "./schedule_occupancy_warning_controller"
application.register("schedule-occupancy-warning", ScheduleOccupancyWarningController)

import ScheduleStyleSelectorController from "./schedule_style_selector_controller"
application.register("schedule-style-selector", ScheduleStyleSelectorController)

import TimeInputController from "./time_input_controller"
application.register("time-input", TimeInputController)

import TrialAppointmentsController from "./trial_appointments_controller"
application.register("trial-appointments", TrialAppointmentsController)

import WorkBlockBlockedController from "./work_block_blocked_controller"
application.register("work-block-blocked", WorkBlockBlockedController)

import WorkBlockUsersController from "./work_block_users_controller"
application.register("work-block-users", WorkBlockUsersController)

import WorkDayScheduleFormController from "./work_day_schedule_form_controller"
application.register("work-day-schedule-form", WorkDayScheduleFormController)
